export default {
  // sync actions
  ACTION_SET: 'SET',
  ACTION_REMOVE: 'REMOVE',
  OPEN_ONE_NOTIFICATION: 'OPEN_ONE_NOTIFICATION',
  OPEN_MANY_NOTIFICATIONS: 'OPEN_MANY_NOTIFICATIONS',
  CLOSE_NOTIFICATION: 'CLOSE_NOTIFICATION',
  REMOVE_FILE_DATA: 'REMOVE_FILE_DATA',

  // async actions
  ACTION_CREATE: 'CREATE',
  ACTION_GET: 'GET',
  ACTION_DELETE: 'DELETE',
  ACTION_UPDATE: 'UPDATE',
  ACTION_UPLOAD: 'UPLOAD'
};
